import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { CrosstabRoutingModule } from '../crosstab/crosstab-routing.module';
import { SnapshotComponent } from './snapshot/snapshot.component';
import { SnapshotRoutingModule } from './snapshot-routing.module';
import { WidgetLibraryComponent } from './widget-library/widget-library.component';
import { SharedModule } from 'src/app/common/shared/shared.module';
import { SnapshotConfiguarationComponent } from './snapshot-configuaration/snapshot-configuaration.component';
import { SnapshotPreviewComponent } from './snapshot-preview/snapshot-preview.component';
import { LeftPanelWidgetLibraryComponent } from './left-panel-widget-library/left-panel-widget-library.component';
import { ChartSelectWidgetLibraryComponent } from './chart-select-widget-library/chart-select-widget-library.component';
import { ChartOutputComponent } from './chart-output/chart-output.component';
import { BarchartComponent } from './modules/barchart/barchart/barchart.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VisualSelectComponent } from './visual-select/visual-select.component';
import { StackedBarChartComponent } from './modules/stacked-bar-chart/stacked-bar-chart/stacked-bar-chart.component';
import { PieChartComponent } from './modules/pie-chart/pie-chart/pie-chart.component';
//import { Piechart12Component } from './custom-snapshot-chart-modules/pie-chart/pie-chart/components/piechart12/piechart12.component';
//import { Piechart12Component } from './modules/pie-chart/pie-chart/components/piechart12/piechart12.component';
import { Piechart12ComponentCustom } from './custom-snapshot-chart-modules/pie-chart/pie-chart/components/piechart12/piechart12.component';
import { ScatterChartComponent } from './modules/scatter-chart/scatter-chart/scatter-chart.component';
import { LollipopChartComponent } from './modules/lollipop-chart/lollipop-chart/lollipop-chart.component';
import { UniqueChartComponent } from './modules/unique-chart/unique-chart/unique-chart.component';
import { AreaChartComponent } from './modules/area-chart/area-chart/area-chart.component';
import { LineOrTrendChartComponent } from './modules/line-or-trend-chart/line-or-trend-chart/line-or-trend-chart.component';
import { ModuleconfigurationComponent } from './moduleconfiguration/module-configuration.component';
import { SharedPopupSnapshotComponent } from './modules/shared-popup/shared-popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { OutputviewComponent } from './outputview/outputview.component';
import { LeftpanelComponent } from './modules/leftpanel/leftpanel.component';
import { StandardWidgetLibraryComponent } from './standard-widget-library/standard-widget-library.component';
import { DocumentclickDirective } from 'src/app/common/directives/documentclickWidget.directive';
import { HeaderNavTextSnapshotComponent } from 'src/app/common/header/header-nav-text-snapshot/header-nav-text-snapshot.component';
import { HeaderNavSnapOutputComponent } from 'src/app/common/header/header-nav-snap-output/header-nav-snap-output.component';
import { HeaderSectionListComponent } from 'src/app/common/header/header-section-list/header-section-list.component';
import { Piechart15Component } from './modules/pie-chart/pie-chart/components/piechart15/piechart15.component';
import { WidgetOutputviewComponent } from './widget-outputview/widget-outputview.component';
import { OutputviewPaginationComponent } from './outputview-pagination/outputview-pagination.component';
import { Widget2OutputviewComponent } from './widget-2-outputview/widget-2-outputview.component';
import { OutputIconsComponent } from './output-icons/output-icons.component';
import { OutputPopupComponent } from './output-popup/output-popup.component';
import { SnapshotChartsparentComponent } from './snapshot-chartsparent/snapshot-chartsparent.component';
import { Barchart01Component } from './modules/barchart/barchart/components/barchart01/barchart01.component';
import { Barchart17ComponentCustom } from './custom-snapshot-chart-modules/barchart/barchart/components/barchart17/barchart17.component';
import { Barchart18ComponentCustom } from './custom-snapshot-chart-modules/barchart/barchart/components/barchart18/barchart18.component';
import { Barchart14Component } from './modules/barchart/barchart/components/barchart14/barchart14.component';
import { Piechart12Component } from './modules/pie-chart/pie-chart/components/piechart12/piechart12.component';
import { Funnelchart1Component } from './modules/unique-chart/unique-chart/components/funnelchart1/funnelchart1.component';
import { Barchart17Component } from './modules/barchart/barchart/components/barchart17/barchart17.component';
import { TableOutputSnapshotComponent } from './shared/table-output-snapshot/table-output-snapshot.component';
import { Lineortrendchart1Component } from './modules/line-or-trend-chart/line-or-trend-chart/components/lineortrendchart1/lineortrendchart1.component';
import { ZipPipe } from 'src/app/zip.pipe';
import { Barchart01ComponentCustom } from './custom-snapshot-chart-modules/barchart/barchart/components/barchart01/barchart01.component';
import { BarChartComponentCustom } from './custom-snapshot-chart-modules/barchart/barchart/barchart.component';
import { StackedBarChartComponentCustom } from './custom-snapshot-chart-modules/stacked-bar-chart/stacked-bar-chart/stacked-bar-chart.component';
import { Stackedbarchart1ComponentCustom } from './custom-snapshot-chart-modules/stacked-bar-chart/stacked-bar-chart/components/stackedbarchart1/stackedbarchart1.component';
import { AreaChartComponentCustom } from './custom-snapshot-chart-modules/area-chart/area-chart/area-chart.component';
import { CombinationChartComponentCustom } from './custom-snapshot-chart-modules/combination-chart/combination-chart/combination-chart.component'
import { PieChartComponentCustom } from './custom-snapshot-chart-modules/pie-chart/pie-chart/pie-chart.component';
import { ScatterChartComponentCustom } from './custom-snapshot-chart-modules/scatter-chart/scatter-chart/scatter-chart.component';
import { LollipopChartComponentCustom } from './custom-snapshot-chart-modules/lollipop-chart/lollipop-chart/lollipop-chart.component';
import { UniqueChartComponentCustom } from './custom-snapshot-chart-modules/unique-chart/unique-chart/unique-chart.component';
import { LineOrTrendChartComponentCustom } from './custom-snapshot-chart-modules/line-or-trend-chart/line-or-trend-chart/line-or-trend-chart.component';
import { LayoutPreviewComponent } from './layout-preview/layout-preview.component';
import { SearchPipe } from './shared/search.pipe';
import { CustomOutputviewComponent } from './CUSTOM-output/custom-outputview/custom-outputview.component';
import { CustomLeftpanelComponent } from './CUSTOM-output/custom-leftpanel/custom-leftpanel.component';
import { CustomWidgetOutputComponent } from './CUSTOM-output/custom-widget-output/custom-widget-output.component';
import { CustomOutputIconsComponent } from './CUSTOM-output/custom-output-icons/custom-output-icons.component';
import { Barchart14ComponentCustom } from './custom-snapshot-chart-modules/barchart/barchart/components/barchart14/barchart14.component';
import { Funnelchart1ComponentCustom } from './custom-snapshot-chart-modules/unique-chart/unique-chart/components/funnelchart1/funnelchart1.component';
import { Piechart11ComponentCustom } from './custom-snapshot-chart-modules/pie-chart/pie-chart/components/piechart11/piechart11.component';
import { Lollipopchart01ComponentCustom } from './custom-snapshot-chart-modules/lollipop-chart/lollipop-chart/components/lollipopchart01/lollipopchart01.component';
import { Lollipopchart02ComponentCustom } from './custom-snapshot-chart-modules/lollipop-chart/lollipop-chart/components/lollipopchart02/lollipopchart02.component';
import { Scatterchart01ComponentCustom } from './custom-snapshot-chart-modules/scatter-chart/scatter-chart/components/scatterchart01/scatterchart01.component';
import { Bubblechart01ComponentCustom } from './custom-snapshot-chart-modules/scatter-chart/scatter-chart/components/bubblechart01/bubblechart01.component';
import { Bubblechart02ComponentCustom } from './custom-snapshot-chart-modules/scatter-chart/scatter-chart/components/bubblechart02/bubblechart02.component';
import { Scatterchart02ComponentCustom } from './custom-snapshot-chart-modules/scatter-chart/scatter-chart/components/scatterchart02/scatterchart02.component';
import { Lineortrendchart1ComponentCustom } from './custom-snapshot-chart-modules/line-or-trend-chart/line-or-trend-chart/components/lineortrendchart1/lineortrendchart1.component';
import { CustomMetricWidgetlibraryComponent } from './custom-metric-widgetlibrary/custom-metric-widgetlibrary.component';
import { Table4Component } from './custom-snapshot-chart-modules/tableView/tableView/components/table4/table4.component';
import { Table3Component } from './custom-snapshot-chart-modules/tableView/tableView/components/table3/table3.component';
import { Table2Component } from './custom-snapshot-chart-modules/tableView/tableView/components/table2/table2.component';
import { Table1ComponentComponent } from './custom-snapshot-chart-modules/tableView/tableView/components/table1-component/table1-component.component';
import { TableViewComponent } from './custom-snapshot-chart-modules/tableView/tableView/table-view-component';
import {Spiderchart02Component} from './custom-snapshot-chart-modules/tableView/tableView/components/spiderchart02/spiderchart02.component'
import { Piechart15ComponentCustom } from './custom-snapshot-chart-modules/pie-chart/pie-chart/components/piechart15/piechart15.component';
import { FillchartwidgetComponent } from './custom-snapshot-chart-modules/tableView/tableView/components/Fillchart/fillchartwidget.component';
import {Piechart19ComponentCustom} from './custom-snapshot-chart-modules/pie-chart/pie-chart/components/piechart19/piechart19.component';
import { GaugechartwidgetComponent } from './custom-snapshot-chart-modules/tableView/tableView/components/Gauge/Gaugechartwidget.component';
import { SelectionSummaryViewComponent } from './selection-summary-view/selection-summary-view.component';
import { LeftpanelnewdesignComponent } from './modules/leftpanelnewdesign/leftpanelnewdesign.component';
import { LineortrendComponentCustom } from './custom-snapshot-chart-modules/tableView/tableView/components/LineorTrendChart/lineortrendchart1.component';
// import { DummyComponent } from './CUSTOM-output/dummy/dummy.component';
import { Piechart23Component } from './custom-snapshot-chart-modules/pie-chart/pie-chart/components/piechart23/piechart23.component';
import { Stackedbarchart2ComponentCustom } from './custom-snapshot-chart-modules/stacked-bar-chart/stacked-bar-chart/components/stackedbarchart2/stackedbarchart2.component';
import { OutputPopupAskMeComponent } from '../chatbotexpand/output-popup/askme_output-popup.component';
import { TopicsConfigurationComponent } from './topics-configuration/topics-configuration.component';

@NgModule({
  declarations: [
    DocumentclickDirective,
    HeaderSectionListComponent,
    HeaderNavSnapOutputComponent,
    HeaderNavTextSnapshotComponent,
    SnapshotComponent,
    WidgetLibraryComponent,
    SnapshotConfiguarationComponent,
    LeftPanelWidgetLibraryComponent,
    SnapshotPreviewComponent,
    ChartSelectWidgetLibraryComponent,
    ChartOutputComponent,
    BarchartComponent,
    StackedBarChartComponent,
    PieChartComponent,
    Piechart12Component, 
    ScatterChartComponent,
    LollipopChartComponent,
    UniqueChartComponent,
    AreaChartComponent,
    LineOrTrendChartComponent,
    VisualSelectComponent,
    ModuleconfigurationComponent,
    SharedPopupSnapshotComponent,
    DeletePopupComponent,
    OutputviewComponent,
    LeftpanelComponent,
    StandardWidgetLibraryComponent,
    Piechart15Component,
    WidgetOutputviewComponent,
    OutputviewPaginationComponent,
    Widget2OutputviewComponent,
    OutputIconsComponent,
    OutputPopupComponent,
    SnapshotChartsparentComponent,
    Barchart01Component,
    Barchart14Component,
    Barchart14ComponentCustom,
    Piechart12ComponentCustom,
    Funnelchart1Component,
    Barchart17Component,
    TableOutputSnapshotComponent,
    Lineortrendchart1Component,
    Barchart01ComponentCustom,
    BarChartComponentCustom,
    Barchart17ComponentCustom,
    Barchart18ComponentCustom,
    CombinationChartComponentCustom,
    StackedBarChartComponentCustom,
    Stackedbarchart1ComponentCustom,
    Stackedbarchart2ComponentCustom,
    AreaChartComponentCustom,
    PieChartComponentCustom,
    ScatterChartComponentCustom,
    LollipopChartComponentCustom,
    UniqueChartComponentCustom,
    Piechart23Component,
    LineOrTrendChartComponentCustom,
    Funnelchart1ComponentCustom,
    Piechart11ComponentCustom,
    Lollipopchart01ComponentCustom,
    Lollipopchart02ComponentCustom,
    Scatterchart01ComponentCustom,
    Scatterchart02ComponentCustom,
    Bubblechart01ComponentCustom,
    Bubblechart02ComponentCustom,
    ZipPipe,
    LeftpanelnewdesignComponent,
    Lineortrendchart1Component,
    Lineortrendchart1ComponentCustom,
    ZipPipe, LayoutPreviewComponent, SearchPipe, CustomOutputviewComponent, CustomLeftpanelComponent, CustomWidgetOutputComponent, CustomOutputIconsComponent, CustomMetricWidgetlibraryComponent,
    TableViewComponent,Table4Component,Table3Component,Table2Component,Table1ComponentComponent,Spiderchart02Component,FillchartwidgetComponent,GaugechartwidgetComponent,Piechart15ComponentCustom, Piechart19ComponentCustom, LeftpanelnewdesignComponent, SelectionSummaryViewComponent, LineortrendComponentCustom,OutputPopupAskMeComponent, TopicsConfigurationComponent
  ],
  imports: [
    CommonModule,
    SnapshotRoutingModule,
    SharedModule,
    DragDropModule,
    ReactiveFormsModule,
    FormsModule,

  ],
  providers: [DecimalPipe],
  exports: [CustomWidgetOutputComponent, OutputPopupComponent, OutputPopupAskMeComponent],
})
export class SnapshotModule { }
